// Cache-bust a `/api/files/` URL by appending `?v=<version>` so a newly
// uploaded image replaces the cached one in the browser immediately.
// Non-`/api/files/` URLs (e.g. Unsplash/Pexels stock photos) are returned
// unchanged so we don't hurt their CDN caching.
export function bust(url, version) {
  if (!url) return url;
  if (!version) return url;
  if (!/\/api\/files\//.test(url)) return url;
  const v = typeof version === "string" ? Date.parse(version) || version : version;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}v=${encodeURIComponent(v)}`;
}

// Request a server-side resized JPEG for `/api/files/` images (no-op otherwise).
export function thumb(url, width = 800) {
  if (!url || !/\/api\/files\//.test(url)) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}w=${width}`;
}
